import React, { FC } from 'react'

import { NoImageIcon } from 'src/components/atoms'

type Props = {
  className?: string
}

export const CommonContentAssetNoImage: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <div className="tw-bg-surface-primary tw-w-full tw-h-full tw-centering">
        <NoImageIcon className="tw-w-[3.7rem]" />
      </div>
    </div>
  )
}
